






import Vue from "vue";
import {Util} from "@/util/util";

export default Vue.extend( {
    name: "ActionIcon",
    props: {
        type: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'small'
        }
    },
    computed: {
        iconSource(): string {
            const config = Util.getConfig();
            const suffix = ('' !== this.type) ? '-' + this.type.toLowerCase() : '';
            return `${config.resourcePath}/dist/img/actions/megaphone${suffix}.svg`;
        },
        styleClass(): string {
            return 'action-icon ' + this.size.toLowerCase();
        }
    }
});

